import { theme } from '@approvalmax/theme';
import styled from 'styled-components';

export const Root = styled.div`
    display: flex;
    flex-direction: column;
    flex-shrink: 0;
    overflow: auto;
    height: 100%;
    border-right: 1px solid ${theme.color.midnight50};
    width: calc(200px + ${theme.container.spacing.large});
`;

export const ScrollableContent = styled.div`
    min-width: fit-content;
    padding: 24px 16px 24px ${theme.container.spacing.large};
    flex-grow: 1;
`;
